<template>
  <div class="main">
    <Header ref="head" :current="4" />

    <div class="about-banner center">
      <img :src="getpath('about/banner', '.png')" alt="" />
    </div>
    <div class="about-module center">
      <div class="about-module-title">
        <div class="line" />
        <img :src="getpath('about/aboutUs', '.png')" alt="" />
      </div>
      <div class="about-module-content">
        <p class="rcontent">
          Uummii专注于打造儿童社交阅读服务，总部位于新加坡，在中国和英国设有专业团队。
        </p>
        <img class="concept" :src="getpath('about/concept', '.png')" alt="" />
      </div>
    </div>
    <div class="about-module back-blue">
      <div class="about-module-title center">
        <img
          style="margin-right: 8px"
          :src="getpath('about/whiteLine', '.png')"
          alt=""
        />
        <img class="partner" :src="getpath('about/partner', '.png')" alt="" />
      </div>
      <div class="about-module-content center">
        <img class="partner" :src="getpath('about/partnerGroup', '.png')" alt="" />
      </div>
    </div>
    <div class="about-module center">
      <div class="about-module-title">
        <div class="line" />
        <img :src="getpath('about/contactUs', '.png')" alt="" />
      </div>
      <div class="about-module-content">
        <div class="platform">
          <div class="platform-row">
            <img
              @click="jumpUrl('https://weibo.com/u/7701010138')"
              :src="getpath('about/weibo', '.png?r=2')"
              alt=""
            />
            <div class="line"></div>
            <img
              @click="jumpUrl('https://www.ximalaya.com/zhubo/275007326')"
              :src="getpath('about/ximalaya', '.png?r=2')"
              alt=""
            />
          </div>
          <div class="platform-row">
            <img
              @click="jumpUrl('https://space.bilibili.com/1897648222')"
              :src="getpath('about/bilibili', '.png?r=2')"
              alt=""
            />
            <div class="line"></div>
            <img
              @click="
                jumpUrl(
                  'https://www.douyin.com/user/MS4wLjABAAAAIK8So74Zs7bvUPZqvZsX24OrsHE36zE17Ezu_V2AtkQ'
                )
              "
              :src="getpath('about/douyin', '.png?r=2')"
              alt=""
            />
          </div>
        </div>
        <div class="qr">
          <img :src="getpath('about/publicAccount', '.png?r=2')" alt="" />
          <img :src="getpath('about/vedioAccount', '.png?r=2')" alt="" />
          <img :src="getpath('about/service', '.png?r=2')" alt="" />
        </div>
        <div class="info">
          <div class="info-row">
            <img class="point" :src="getpath('about/point', '.png')" alt="" />
            <p>商务合作</p>
            <img
              class="mail"
              :src="getpath('about/mail', '.png')"
              alt=""
            />
            <p>hezuo@uummii.life</p>
          </div>
          <div class="info-row">
            <img class="point" :src="getpath('about/point', '.png')" alt="" />
            <p>人才招聘</p>
            <img
              class="telephone"
              :src="getpath('about/telephone-Icon', '.png')"
              alt=""
            />
            <p>010-5332 6160</p>
          </div>
          <div class="info-row">
            <img class="point" :src="getpath('about/point', '.png')" alt="" />
            <p>联系客服</p>
            <img
              class="telephone"
              :src="getpath('about/telephone-Icon', '.png')"
              alt=""
            />
            <p>136-8104-2753</p>
            <img
              class="mail"
              :src="getpath('about/mail', '.png')"
              alt=""
            />
            <p>kefu@uummii.life</p>
          </div>
          <div class="info-row">
            <img class="point" :src="getpath('about/point', '.png')" alt="" />
            <p>公司地址 北京市朝阳区朝阳门外大街18号丰联广场1609-1610</p>
          </div>
        </div>
      </div>
    </div>
    <Footer :color="'#1C9AF2'" />
  </div>
</template>
<script>
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";

export default {
  components: {
    Header,
    Footer,
  },
	mounted() {
		document.title = '关于Uummii';
	},
  data() {
    return {
      content: "",
    };
  },
  methods: {
    jumpUrl(url) {
      window.open(url, "_black");
    },
  },
};
</script>
<style lang="scss" scope>
.main {
  width: 100%;
  margin: 0 auto;
  min-width: 414px;
  color: rgba(51, 51, 51, 1);
  padding-top: 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  .center{
    width: 100%;
    margin: 0 auto;
  }
  .about-banner {
    margin-top: 10px;
    width: 100%;
    img {
      width: 100%;
    }
  }
  .about-module {
    width: 100%;
    padding: 50px;
    box-sizing: border-box;
    .about-module-title {
      display: flex;
      margin-bottom: 30px;
      .line {
        width: 13px;
        height: 40px;
        border-radius: 6.5px 6.5px 6.5px 6.5px;
        background: rgba(27, 177, 254, 1);
        margin-right: 13px;
      }
      .partner {
        height: 34px;
      }
      img {
        height: 40px;
      }
    }
    .about-module-content {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .rcontent {
        width: 100%;
        font-size: 26px;
        font-weight: 500;
        text-align: justifyLeft;
        color: #282727;
        line-height: 38px;
        letter-spacing: 0px;
        padding-left: 20px;
        margin-bottom: 20px;
      }
      .concept {
        width: 615px;
        margin-left: -14px;
      }
      .partner {
        margin: 0 0 0 0px;
        width: 600px;
      }
      .platform {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        .platform-row {
          margin-top: 32px;
          display: flex;

          img {
            padding-left: 64px;
            padding-right: 64px;
            width: 215px;
            height: 57px;
          }
          .line {
            width: 2px;
            height: 48px;
            background: rgba(0, 0, 0, 1);
          }
        }
      }
      .qr {
        width: 100%;
        display: flex;
        justify-content: space-around;
        margin: 48px 0 22px 0;
        img {
          width: 133px;
          height: 176px;
        }
      }
      .info {
        .info-row {
          display: flex;
          align-items: center;
          margin-bottom: 12px;
          .point {
            margin-left: 12px;
            width: 14px;
            height: 15px;
          }
          .mail {
            margin-left: 12px;
            width: 22px;
            height: 15px;
          }
          .telephone {
            margin-left: 12px;
            width: 19px;
            height: 19px;
          }
          p {
            margin-left: 12px;
            font-weight: Regular;
            font-size: 20px;
            text-align: left;
            color: #1c1c1c 100%;
          }
        }
        .info-row:nth-last-col {
          margin-bottom: 0;
        }
      }
      img {
        width: 100%;
      }
    }
  }
  .back-blue {
    background-color: #1c9af2;
  }
  .slide-right {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    position: fixed;
    right: 20px;
    top: 50%;
    width: 66px;
    height: 140px;
    margin-top: -105px;
    z-index: 100;

    .slide-item {
      display: block;
      width: 100%;
    }

    .slide-active {
      display: none;
      width: 100%;
    }
    .slide-lession {
      cursor: pointer;
      .ewm {
        position: absolute;
        width: 140px;
        height: auto;
        left: -160px;
        top: 20%;
        transform: scale(0);
        transform-origin: right center;
        transition: transform 0.3s linear;
      }
      &:hover {
        .ewm {
          transform: scale(1);
        }
        .slide-item {
          display: none;
        }

        .slide-active {
          display: block;
        }
      }
    }
    .slide-upload {
      position: relative;
      .ewmbox {
        position: absolute;
        width: 300px;
        height: auto;
        left: -320px;
        top: -20%;
        transform: scale(0);
        transform-origin: right center;
        transition: transform 0.3s linear;
        .ewmup {
          width: 140px;
          height: auto;
          &:nth-child(1) {
            margin-right: 20px;
          }
        }
      }

      .ewm {
        position: absolute;
        width: 140px;
        height: 140px;
        left: -160px;
        top: -20%;
        transform: scale(0);
        transform-origin: right center;
        transition: transform 0.3s linear;
        &.upload {
          height: auto;
        }
      }
      &:hover {
        .ewm,
        .ewmbox {
          transform: scale(1);
        }
        .slide-item {
          display: none;
        }

        .slide-active {
          display: block;
        }
      }
    }
  }
}
	@media screen and (min-width: 750px) {
		.main{
      .center{
        width: 750px !important;
        margin: 0 auto;
      }
      .about-module{
        .about-module-content{
          .partner{
            width: 100% !important;
          }
        }
      }
		}
	}
</style>





// WEBPACK FOOTER //
// src/page/about.vue